const AuthHeader = () => {
  return (
    <header className="flex items-center px-4 py-2">
      <div className="flex items-center p-4">
        <img src="/logo.svg" alt="Vizops Logo" className="h-10" />
      </div>
    </header>
  )
}

export default AuthHeader
